// BROAD SPECIALTIES

const healthcare_services_def = [
  "Healthcare Services",
  "Medical Specialties",
  "Healthcare Products",
  "Healthcare Centers",
  "Health Sciences",
];

const financial_services_def = [
  "Banking Services",
  "Investment Services",
  "Capital Markets",
  "Insurance",
  "Payment Services",
  "Financial Infrastructure",
  "Financial Advisory",
];

const technology_services_def = [
  "Information Technology Services",
  "Software Development",
  "Hardware Manufacturing",
  "Telecommunications",
  "Semiconductors",
  "Internet Services",
  "Artificial Intelligence and Machine Learning",
  "Cybersecurity",
  "Consumer Electronics",
];

const consumer_discretionary_def = [
  "Retail",
  "Automotive",
  "Entertainment",
  "Travel and Hospitality",
  "Luxury Goods",
  "Home Improvement",
  "Fashion and Apparel",
  "E-commerce",
  "Personal Services",
];

const consumer_staples_def = [
  "Food and Beverages",
  "Household Products",
  "Personal Care",
  "Grocery Retail",
  "Consumer Packaged Goods",
  "Agriculture",
  "Tobacco",
  "Drug Retail",
];

const industrials_def = [
  "Manufacturing",
  "Transportation",
  "Aerospace and Defense",
  "Construction",
  "Engineering Services",
  "Industrial Technology",
  "Waste Management",
  "Building Products",
  "Professional Services",
];

const energy_def = [
  "Oil and Gas",
  "Renewable Energy",
  "Energy Equipment",
  "Energy Infrastructure",
  "Energy Services",
  "Nuclear Energy",
  "Energy Technology",
  "Carbon Management",
];

const materials_def = [
  "Chemicals",
  "Metals and Mining",
  "Construction Materials",
  "Paper and Forest Products",
  "Packaging Materials",
  "Advanced Materials",
  "Industrial Materials",
  "Recycling and Processing",
];

const utilities_def = [
  "Electric Power",
  "Natural Gas Distribution",
  "Water Services",
  "Multi-Utilities",
  "Independent Power",
  "Grid Operations",
  "Smart Utilities",
  "District Energy",
];

const real_estate_def = [
  "Commercial Property",
  "Residential Property",
  "Real Estate Investment",
  "Property Management",
  "Real Estate Development",
  "Specialized Properties",
  "Land Development",
  "Real Estate Services",
];

const communication_services_def = [
  "Telecommunications",
  "Media Entertainment",
  "Digital Media",
  "Broadcasting",
  "Publishing",
  "Interactive Media",
  "Advertising",
  "Network Infrastructure",
];

const government_public_sector_def = [
  "Public Administration",
  "Defense and Security",
  "Public Healthcare",
  "Education",
  "Infrastructure",
  "Social Services",
  "Environmental Services",
  "Municipal Services",
];

export const broad_specialty_defs = {
  Healthcare: healthcare_services_def,
  Financials: financial_services_def,
  Technology: technology_services_def,
  "Consumer Discretionary": consumer_discretionary_def,
  "Consumer Staples": consumer_staples_def,
  Industrials: industrials_def,
  Energy: energy_def,
  Materials: materials_def,
  Utilities: utilities_def,
  "Real Estate": real_estate_def,
  "Communication Services": communication_services_def,
  "Government/Public Sector": government_public_sector_def,
};

// NARROW SPECIALTIES

const financial_categories = {
  "Banking Services": [
    "Retail Banking",
    "Commercial Banking",
    "Corporate Banking",
    "Investment Banking",
    "Private Banking",
    "Digital Banking",
    "Mobile Banking",
    "Credit Unions",
    "Community Banks",
    "Mortgage Banking",
    "Consumer Lending",
    "Business Lending",
    "International Banking",
    "Microfinance",
  ],

  "Investment Services": [
    "Asset Management",
    "Fund Management",
    "Private Equity",
    "Venture Capital",
    "Hedge Funds",
    "Mutual Funds",
    "ETF Management",
    "Portfolio Management",
    "Investment Research",
    "Alternative Investments",
    "Real Estate Investment",
    "Pension Fund Management",
    "Index Fund Management",
    "Quantitative Investment",
    "Sustainable Investing",
  ],

  "Capital Markets": [
    "Stock Exchanges",
    "Bond Markets",
    "Derivatives Trading",
    "Commodities Trading",
    "Foreign Exchange",
    "Securities Brokerage",
    "Market Making",
    "Prime Brokerage",
    "Institutional Trading",
    "Algorithmic Trading",
    "Dark Pools",
    "Fixed Income",
    "Equity Capital Markets",
    "Debt Capital Markets",
    "Securities Clearing",
  ],

  Insurance: [
    "Life Insurance",
    "Property Insurance",
    "Casualty Insurance",
    "Health Insurance",
    "Reinsurance",
    "Commercial Insurance",
    "Personal Insurance",
    "Insurance Brokerage",
    "Risk Assessment",
    "Claims Management",
    "Underwriting",
    "Actuarial Services",
    "Insurance Technology",
    "Specialty Insurance",
    "Parametric Insurance",
  ],

  "Payment Services": [
    "Credit Card Networks",
    "Payment Processing",
    "Digital Payments",
    "Mobile Payments",
    "Payment Gateways",
    "Merchant Services",
    "ACH Processing",
    "Wire Transfers",
    "Cross-border Payments",
    "Real-time Payments",
    "Payment Security",
    "E-wallet Services",
    "Point of Sale Systems",
    "Payment Infrastructure",
    "Blockchain Payments",
  ],

  "Financial Infrastructure": [
    "Core Banking Systems",
    "Trading Platforms",
    "Settlement Systems",
    "Clearing Houses",
    "Market Data Services",
    "Risk Management Systems",
    "Compliance Systems",
    "Financial Software",
    "Banking APIs",
    "Credit Bureaus",
    "Financial Networks",
    "Data Analytics",
    "Cybersecurity",
    "Regulatory Technology",
    "Identity Verification",
  ],

  "Financial Advisory": [
    "Corporate Finance",
    "Wealth Management",
    "Financial Planning",
    "Investment Advisory",
    "Tax Advisory",
    "M&A Advisory",
    "Restructuring Advisory",
    "Risk Advisory",
    "Estate Planning",
    "Retirement Planning",
    "Business Valuation",
    "Family Office Services",
    "Financial Research",
    "Strategic Consulting",
    "Regulatory Consulting",
  ],
};

const technology_categories = {
  "Information Technology Services": [
    "IT Consulting",
    "System Integration",
    "Managed Services",
    "Cloud Services",
    "Technical Support",
    "IT Infrastructure",
    "Network Services",
    "Data Center Services",
    "Digital Transformation",
    "IT Strategy",
    "Enterprise Architecture",
    "Technology Implementation",
    "IT Operations",
    "Service Desk",
    "Technology Training",
  ],

  "Software Development": [
    "Enterprise Software",
    "Mobile Applications",
    "Cloud Solutions",
    "Custom Software",
    "Application Development",
    "Software Testing",
    "DevOps",
    "Database Development",
    "Web Development",
    "API Development",
    "System Software",
    "Embedded Software",
    "Gaming Software",
    "Software Architecture",
    "Quality Assurance",
  ],

  "Hardware Manufacturing": [
    "Computer Hardware",
    "Servers",
    "Networking Equipment",
    "Storage Devices",
    "Peripherals",
    "Circuit Boards",
    "Electronic Components",
    "Industrial Hardware",
    "Computer Assembly",
    "Hardware Testing",
    "Hardware Design",
    "Manufacturing Equipment",
    "Quality Control",
    "Hardware Integration",
    "Prototype Development",
  ],

  Telecommunications: [
    "Network Infrastructure",
    "Wireless Communications",
    "Fiber Optics",
    "Telecom Equipment",
    "Mobile Networks",
    "Satellite Communications",
    "VoIP Services",
    "Network Operations",
    "Telecom Software",
    "Data Transmission",
    "Network Security",
    "Broadband Services",
    "5G Technology",
    "Telecom Testing",
    "Network Management",
  ],

  Semiconductors: [
    "Chip Design",
    "Chip Manufacturing",
    "Integrated Circuits",
    "Microprocessors",
    "Memory Chips",
    "Semiconductor Equipment",
    "Analog Semiconductors",
    "Digital Semiconductors",
    "Power Semiconductors",
    "Semiconductor Testing",
    "Semiconductor Packaging",
    "Foundry Services",
    "Semiconductor Materials",
    "Chip Architecture",
    "Process Development",
  ],

  "Internet Services": [
    "Search Engines",
    "Social Media",
    "E-commerce Platforms",
    "Cloud Computing",
    "Web Hosting",
    "Content Delivery",
    "Online Advertising",
    "Internet Infrastructure",
    "Digital Platforms",
    "Streaming Services",
    "Internet Security",
    "Web Services",
    "Internet Protocol",
    "Domain Services",
    "Internet Software",
  ],

  "Artificial Intelligence and Machine Learning": [
    "Machine Learning",
    "Deep Learning",
    "Natural Language Processing",
    "Computer Vision",
    "Robotics",
    "AI Infrastructure",
    "AI Applications",
    "Neural Networks",
    "Predictive Analytics",
    "AI Consulting",
    "AI Research",
    "AI Integration",
    "AI Software",
    "AI Hardware",
    "AI Ethics",
  ],

  Cybersecurity: [
    "Network Security",
    "Application Security",
    "Cloud Security",
    "Data Protection",
    "Identity Management",
    "Security Operations",
    "Threat Detection",
    "Incident Response",
    "Security Consulting",
    "Encryption",
    "Security Testing",
    "Security Software",
    "Security Hardware",
    "Risk Management",
    "Compliance",
  ],

  "Consumer Electronics": [
    "Smartphones",
    "Tablets",
    "Smart Home Devices",
    "Wearable Technology",
    "Gaming Consoles",
    "Audio Equipment",
    "Display Technology",
    "Personal Computers",
    "Digital Cameras",
    "Consumer IoT",
    "Entertainment Systems",
    "Electronic Accessories",
    "Consumer Software",
    "Product Design",
    "Consumer Support",
  ],
};

const consumer_discretionary_categories = {
  Retail: [
    "Department Stores",
    "Specialty Retail",
    "Electronics Retail",
    "Sporting Goods",
    "Home Furnishings",
    "Jewelry Retail",
    "Book Stores",
    "Toy Stores",
    "Pet Supplies",
    "Office Supplies",
    "Art Supplies",
    "Music Stores",
    "Hobby Shops",
    "Gift Shops",
    "Outdoor Recreation",
  ],

  Automotive: [
    "Auto Manufacturing",
    "Auto Dealerships",
    "Auto Parts",
    "Auto Service Centers",
    "Electric Vehicles",
    "Motorcycle Sales",
    "RV Dealers",
    "Auto Accessories",
    "Car Rental",
    "Auto Financing",
    "Auto Technology",
    "Custom Vehicles",
    "Auto Body Shops",
    "Performance Parts",
    "Classic Cars",
  ],

  Entertainment: [
    "Movie Theaters",
    "Theme Parks",
    "Gaming",
    "Sports Entertainment",
    "Live Events",
    "Streaming Services",
    "Music Industry",
    "Performing Arts",
    "Casinos",
    "Entertainment Venues",
    "Recreation Centers",
    "Virtual Entertainment",
    "Family Entertainment",
    "Concert Production",
    "Event Management",
  ],

  "Travel and Hospitality": [
    "Hotels",
    "Airlines",
    "Cruise Lines",
    "Resorts",
    "Travel Agencies",
    "Tour Operators",
    "Restaurants",
    "Vacation Rentals",
    "Business Travel",
    "Adventure Tourism",
    "Hospitality Services",
    "Travel Technology",
    "Tourist Attractions",
    "Booking Services",
    "Travel Insurance",
  ],

  "Luxury Goods": [
    "Designer Fashion",
    "Fine Jewelry",
    "Luxury Watches",
    "Premium Accessories",
    "Luxury Cars",
    "Fine Art",
    "Premium Electronics",
    "Luxury Home Goods",
    "Designer Furniture",
    "Luxury Travel",
    "Private Jets",
    "Yachts",
    "Fine Wine",
    "Luxury Retail",
    "Bespoke Services",
  ],

  "Home Improvement": [
    "Home Centers",
    "Hardware Stores",
    "Furniture Stores",
    "Flooring",
    "Kitchen and Bath",
    "Paint and Wallpaper",
    "Garden Centers",
    "Home Decor",
    "Lighting",
    "Storage Solutions",
    "Home Security",
    "Smart Home",
    "Custom Cabinets",
    "Window Treatments",
    "Renovation Services",
  ],

  "Fashion and Apparel": [
    "Designer Clothing",
    "Fast Fashion",
    "Athletic Wear",
    "Footwear",
    "Accessories",
    "Children's Clothing",
    "Formal Wear",
    "Sportswear",
    "Intimate Apparel",
    "Fashion Design",
    "Fashion Manufacturing",
    "Fashion Technology",
    "Sustainable Fashion",
    "Fashion Distribution",
    "Fashion Retail",
  ],

  "E-commerce": [
    "Online Marketplaces",
    "Digital Retail",
    "Mobile Commerce",
    "Social Commerce",
    "Subscription Services",
    "Digital Payments",
    "E-commerce Platform",
    "Fulfillment Services",
    "Digital Marketing",
    "Customer Analytics",
    "Logistics Solutions",
    "Digital Content",
    "Online Auctions",
    "Comparison Shopping",
    "Direct-to-Consumer",
  ],

  "Personal Services": [
    "Fitness Centers",
    "Beauty Salons",
    "Spa Services",
    "Personal Training",
    "Education Services",
    "Pet Services",
    "Wedding Services",
    "Photography Services",
    "Child Care",
    "Personal Shopping",
    "Lifestyle Coaching",
    "Wellness Services",
    "Concierge Services",
    "Event Planning",
    "Professional Development",
  ],
};

const consumer_staples_categories = {
  "Food and Beverages": [
    "Food Processing",
    "Beverage Manufacturing",
    "Dairy Products",
    "Meat Processing",
    "Bakery Products",
    "Snack Foods",
    "Frozen Foods",
    "Canned Foods",
    "Coffee and Tea",
    "Bottled Water",
    "Soft Drinks",
    "Health Foods",
    "Baby Food",
    "Pet Food",
    "Food Ingredients",
    "Condiments",
    "Functional Beverages",
    "Plant-based Foods",
  ],

  "Household Products": [
    "Cleaning Supplies",
    "Laundry Products",
    "Paper Products",
    "Storage Solutions",
    "Air Fresheners",
    "Pest Control",
    "Kitchen Supplies",
    "Bathroom Products",
    "Home Care Chemicals",
    "Disposable Products",
    "Household Appliances",
    "Home Safety Products",
    "Waste Management Products",
    "Household Textiles",
    "Basic Home Maintenance",
  ],

  "Personal Care": [
    "Hygiene Products",
    "Oral Care",
    "Hair Care",
    "Skin Care",
    "Baby Care",
    "Feminine Care",
    "Deodorants",
    "Soap and Bath Products",
    "First Aid",
    "Basic Cosmetics",
    "Men's Grooming",
    "Adult Care Products",
    "Hand Sanitizers",
    "Personal Cleaning",
    "Basic Healthcare Items",
  ],

  "Grocery Retail": [
    "Supermarkets",
    "Convenience Stores",
    "Discount Stores",
    "Wholesale Clubs",
    "Specialty Food Stores",
    "Online Grocery",
    "Farmers Markets",
    "Food Distribution",
    "Ethnic Food Stores",
    "Natural Food Stores",
    "Grocery Technology",
    "Food Service Distribution",
    "Retail Operations",
    "Supply Chain",
    "Inventory Management",
  ],

  "Consumer Packaged Goods": [
    "Food Packaging",
    "Beverage Packaging",
    "Personal Care Packaging",
    "Household Product Packaging",
    "Private Label Products",
    "Brand Management",
    "Product Development",
    "Quality Control",
    "Supply Chain Management",
    "Consumer Research",
    "Packaging Innovation",
    "Distribution Systems",
    "Manufacturing",
    "Product Safety",
    "Sustainable Packaging",
  ],

  Agriculture: [
    "Crop Farming",
    "Livestock",
    "Aquaculture",
    "Agricultural Products",
    "Feed Production",
    "Seed Development",
    "Fertilizers",
    "Agricultural Chemicals",
    "Farm Equipment",
    "Agricultural Technology",
    "Sustainable Agriculture",
    "Organic Farming",
    "Food Processing",
    "Agricultural Distribution",
    "Agricultural Research",
  ],

  Tobacco: [
    "Cigarette Manufacturing",
    "Smokeless Tobacco",
    "E-cigarettes",
    "Vaping Products",
    "Tobacco Distribution",
    "Nicotine Products",
    "Alternative Products",
    "Tobacco Agriculture",
    "Smoking Accessories",
    "Product Development",
    "Quality Control",
    "Regulatory Compliance",
    "Manufacturing Equipment",
    "Packaging Solutions",
    "Research and Development",
  ],

  "Drug Retail": [
    "Pharmacy Chains",
    "Independent Pharmacies",
    "Online Pharmacies",
    "Healthcare Products",
    "Prescription Services",
    "Over-the-Counter Drugs",
    "Medical Supplies",
    "Pharmacy Technology",
    "Healthcare Services",
    "Wellness Products",
    "Health Monitoring",
    "Patient Care",
    "Inventory Management",
    "Healthcare Distribution",
    "Pharmacy Operations",
  ],
};

const industrials_categories = {
  Manufacturing: [
    "Industrial Machinery",
    "Machine Tools",
    "Manufacturing Equipment",
    "Process Equipment",
    "Assembly Systems",
    "Metal Fabrication",
    "Industrial Components",
    "Precision Manufacturing",
    "Production Systems",
    "Quality Control Equipment",
    "Manufacturing Software",
    "Industrial Supplies",
    "Custom Manufacturing",
    "Contract Manufacturing",
    "Manufacturing Technology",
  ],

  Transportation: [
    "Air Freight",
    "Rail Transport",
    "Maritime Shipping",
    "Trucking",
    "Logistics Services",
    "Supply Chain Management",
    "Freight Forwarding",
    "Transportation Infrastructure",
    "Fleet Management",
    "Container Services",
    "Distribution Centers",
    "Intermodal Transport",
    "Last-Mile Delivery",
    "Transportation Technology",
    "Cargo Handling",
  ],

  "Aerospace and Defense": [
    "Aircraft Manufacturing",
    "Defense Systems",
    "Space Technology",
    "Military Equipment",
    "Aviation Systems",
    "Missile Systems",
    "Naval Systems",
    "Defense Electronics",
    "Aerospace Components",
    "Military Vehicles",
    "Surveillance Systems",
    "Combat Systems",
    "Aviation Services",
    "Space Systems",
    "Defense Technology",
  ],

  Construction: [
    "Commercial Construction",
    "Residential Construction",
    "Infrastructure Development",
    "Industrial Construction",
    "Project Management",
    "Construction Equipment",
    "Building Systems",
    "Site Development",
    "Construction Technology",
    "Sustainable Construction",
    "Renovation Services",
    "Specialty Construction",
    "Construction Management",
    "Design-Build Services",
    "Construction Materials",
  ],

  "Engineering Services": [
    "Civil Engineering",
    "Mechanical Engineering",
    "Electrical Engineering",
    "Industrial Engineering",
    "Environmental Engineering",
    "Structural Engineering",
    "Process Engineering",
    "Systems Engineering",
    "Engineering Design",
    "Technical Consulting",
    "Project Engineering",
    "Engineering Software",
    "Engineering Analysis",
    "Engineering Management",
    "Engineering Research",
  ],

  "Industrial Technology": [
    "Automation Systems",
    "Robotics",
    "Process Control",
    "Industrial IoT",
    "Smart Manufacturing",
    "Digital Twin Technology",
    "Industrial Software",
    "Machine Learning",
    "Industrial AI",
    "Predictive Maintenance",
    "Industrial Networks",
    "Factory Automation",
    "Industrial Analytics",
    "Industrial Cloud",
    "Edge Computing",
  ],

  "Waste Management": [
    "Waste Collection",
    "Recycling Services",
    "Hazardous Waste",
    "Environmental Services",
    "Waste Treatment",
    "Waste-to-Energy",
    "Industrial Cleaning",
    "Water Treatment",
    "Environmental Consulting",
    "Remediation Services",
    "Disposal Services",
    "Resource Recovery",
    "Environmental Technology",
    "Circular Economy",
    "Sustainable Solutions",
  ],

  "Building Products": [
    "Construction Materials",
    "HVAC Systems",
    "Electrical Systems",
    "Plumbing Systems",
    "Building Automation",
    "Security Systems",
    "Lighting Systems",
    "Roofing Products",
    "Insulation Materials",
    "Windows and Doors",
    "Structural Products",
    "Interior Products",
    "Exterior Products",
    "Smart Building Systems",
    "Green Building Materials",
  ],

  "Professional Services": [
    "Industrial Consulting",
    "Technical Services",
    "Facility Management",
    "Security Services",
    "Staffing Services",
    "Business Services",
    "Project Management",
    "Quality Assurance",
    "Safety Services",
    "Maintenance Services",
    "Training Services",
    "Compliance Services",
    "Asset Management",
    "Risk Management",
    "Operations Consulting",
  ],
};

const energy_categories = {
  "Oil and Gas": [
    "Oil Exploration",
    "Oil Production",
    "Natural Gas Production",
    "Oil Refining",
    "Gas Processing",
    "Petroleum Distribution",
    "Pipeline Operations",
    "Offshore Drilling",
    "Oil Field Services",
    "Gas Storage",
    "LNG Processing",
    "Oil Trading",
    "Gas Trading",
    "Petrochemicals",
    "Fuel Retail",
  ],

  "Renewable Energy": [
    "Solar Power",
    "Wind Energy",
    "Hydroelectric Power",
    "Geothermal Energy",
    "Biomass Energy",
    "Tidal Energy",
    "Green Hydrogen",
    "Energy Storage",
    "Grid Integration",
    "Renewable Development",
    "Clean Energy Projects",
    "Sustainable Power",
    "Energy Efficiency",
    "Microgrids",
    "Power Purchase Agreements",
  ],

  "Energy Equipment": [
    "Drilling Equipment",
    "Power Generation Equipment",
    "Transmission Equipment",
    "Distribution Equipment",
    "Solar Equipment",
    "Wind Turbines",
    "Energy Storage Systems",
    "Control Systems",
    "Monitoring Equipment",
    "Testing Equipment",
    "Safety Equipment",
    "Maintenance Tools",
    "Specialized Vehicles",
    "Component Manufacturing",
    "Equipment Services",
  ],

  "Energy Infrastructure": [
    "Power Plants",
    "Transmission Lines",
    "Distribution Networks",
    "Oil Pipelines",
    "Gas Pipelines",
    "Storage Facilities",
    "Processing Plants",
    "Terminal Operations",
    "Grid Infrastructure",
    "Substations",
    "Smart Grid Systems",
    "Energy Ports",
    "Charging Infrastructure",
    "Fuel Terminals",
    "Infrastructure Maintenance",
  ],

  "Energy Services": [
    "Drilling Services",
    "Well Services",
    "Equipment Maintenance",
    "Technical Consulting",
    "Engineering Services",
    "Project Management",
    "Energy Efficiency Services",
    "Environmental Services",
    "Safety Services",
    "Testing Services",
    "Inspection Services",
    "Energy Trading Services",
    "Field Services",
    "Logistics Support",
    "Professional Services",
  ],

  "Nuclear Energy": [
    "Nuclear Power Generation",
    "Nuclear Plant Operations",
    "Nuclear Fuel Processing",
    "Reactor Technology",
    "Nuclear Safety Systems",
    "Waste Management",
    "Plant Maintenance",
    "Nuclear Engineering",
    "Radiation Protection",
    "Nuclear Research",
    "Plant Construction",
    "Decommissioning Services",
    "Nuclear Materials",
    "Safety Consulting",
    "Regulatory Compliance",
  ],

  "Energy Technology": [
    "Smart Grid Technology",
    "Energy Storage Solutions",
    "Energy Management Systems",
    "Grid Optimization",
    "Digital Technologies",
    "IoT Solutions",
    "Energy Analytics",
    "Monitoring Systems",
    "Control Technologies",
    "Energy Software",
    "Blockchain Energy",
    "AI Applications",
    "Energy Data Management",
    "Automation Systems",
    "Energy Trading Platforms",
  ],

  "Carbon Management": [
    "Carbon Capture",
    "Carbon Storage",
    "Emissions Monitoring",
    "Carbon Trading",
    "Emissions Reduction",
    "Clean Technology",
    "Carbon Offsetting",
    "Environmental Compliance",
    "Carbon Accounting",
    "Sustainability Services",
    "Climate Technology",
    "Carbon Credits",
    "Emissions Testing",
    "Carbon Consulting",
    "Environmental Solutions",
  ],
};

const materials_categories = {
  Chemicals: [
    "Basic Chemicals",
    "Specialty Chemicals",
    "Agricultural Chemicals",
    "Industrial Chemicals",
    "Petrochemicals",
    "Polymer Chemistry",
    "Fine Chemicals",
    "Chemical Processing",
    "Organic Chemicals",
    "Inorganic Chemicals",
    "Performance Chemicals",
    "Chemical Distribution",
    "Green Chemistry",
    "Chemical Manufacturing",
    "Chemical Research",
  ],

  "Metals and Mining": [
    "Iron Ore Mining",
    "Precious Metals",
    "Base Metals",
    "Metal Processing",
    "Mining Operations",
    "Mineral Extraction",
    "Metal Fabrication",
    "Mining Equipment",
    "Exploration Services",
    "Metallurgy",
    "Mining Technology",
    "Resource Development",
    "Metal Recycling",
    "Mining Safety",
    "Mineral Processing",
  ],

  "Construction Materials": [
    "Cement Production",
    "Concrete Products",
    "Aggregates",
    "Building Materials",
    "Asphalt Products",
    "Insulation Materials",
    "Structural Materials",
    "Masonry Products",
    "Construction Composites",
    "Material Testing",
    "Sustainable Materials",
    "Material Distribution",
    "Quality Control",
    "Material Innovation",
    "Green Building Materials",
  ],

  "Paper and Forest Products": [
    "Paper Manufacturing",
    "Pulp Production",
    "Forest Management",
    "Wood Products",
    "Packaging Paper",
    "Tissue Products",
    "Specialty Paper",
    "Sustainable Forestry",
    "Paper Converting",
    "Timber Products",
    "Paper Recycling",
    "Forest Conservation",
    "Paper Distribution",
    "Wood Processing",
    "Biomass Products",
  ],

  "Packaging Materials": [
    "Plastic Packaging",
    "Paper Packaging",
    "Metal Packaging",
    "Glass Packaging",
    "Flexible Packaging",
    "Rigid Packaging",
    "Smart Packaging",
    "Sustainable Packaging",
    "Protective Packaging",
    "Food Packaging",
    "Industrial Packaging",
    "Packaging Design",
    "Packaging Technology",
    "Package Testing",
    "Packaging Solutions",
  ],

  "Advanced Materials": [
    "Composites",
    "Nanomaterials",
    "Smart Materials",
    "Advanced Polymers",
    "Engineered Materials",
    "Functional Materials",
    "Advanced Ceramics",
    "Electronic Materials",
    "Biomaterials",
    "Material Science",
    "Advanced Coatings",
    "Material Testing",
    "Research Development",
    "Material Design",
    "Advanced Manufacturing",
  ],

  "Industrial Materials": [
    "Raw Materials",
    "Processed Materials",
    "Industrial Metals",
    "Industrial Minerals",
    "Manufacturing Materials",
    "Material Processing",
    "Material Handling",
    "Quality Control",
    "Material Testing",
    "Supply Chain",
    "Material Distribution",
    "Industrial Solutions",
    "Material Innovation",
    "Process Optimization",
    "Material Management",
  ],

  "Recycling and Processing": [
    "Material Recovery",
    "Waste Processing",
    "Recycling Technology",
    "Material Sorting",
    "Sustainable Processing",
    "Resource Recovery",
    "Circular Economy",
    "Processing Equipment",
    "Recycling Operations",
    "Material Conversion",
    "Environmental Services",
    "Waste Management",
    "Process Innovation",
    "Recycling Solutions",
    "Sustainability Services",
  ],
};

const utilities_categories = {
  "Electric Power": [
    "Power Generation",
    "Power Distribution",
    "Transmission Networks",
    "Renewable Integration",
    "Substation Operations",
    "Grid Management",
    "Power Trading",
    "Load Management",
    "System Planning",
    "Power Quality",
    "Emergency Response",
    "Customer Service",
    "Metering Services",
    "Maintenance Operations",
    "Regulatory Compliance",
  ],

  "Natural Gas Distribution": [
    "Gas Pipeline Networks",
    "Gas Storage",
    "Pressure Management",
    "Gas Metering",
    "Pipeline Maintenance",
    "Safety Systems",
    "Gas Trading",
    "Distribution Planning",
    "Emergency Response",
    "Customer Connections",
    "System Monitoring",
    "Leak Detection",
    "Regulatory Compliance",
    "Infrastructure Development",
    "Quality Control",
  ],

  "Water Services": [
    "Water Treatment",
    "Water Distribution",
    "Wastewater Management",
    "Water Quality",
    "Infrastructure Maintenance",
    "Sanitation Services",
    "Storm Water Management",
    "Water Conservation",
    "Water Testing",
    "System Monitoring",
    "Emergency Response",
    "Customer Service",
    "Regulatory Compliance",
    "Environmental Protection",
    "Resource Management",
  ],

  "Multi-Utilities": [
    "Integrated Services",
    "Combined Operations",
    "Service Integration",
    "Resource Management",
    "Infrastructure Planning",
    "Customer Management",
    "Billing Systems",
    "Emergency Response",
    "Regulatory Compliance",
    "System Optimization",
    "Asset Management",
    "Service Quality",
    "Environmental Management",
    "Safety Programs",
    "Community Relations",
  ],

  "Independent Power": [
    "Power Generation",
    "Energy Trading",
    "Plant Operations",
    "Capacity Management",
    "Grid Connection",
    "Market Operations",
    "Asset Management",
    "Power Purchase Agreements",
    "Regulatory Compliance",
    "Environmental Management",
    "System Maintenance",
    "Performance Optimization",
    "Risk Management",
    "Project Development",
    "Resource Planning",
  ],

  "Grid Operations": [
    "Transmission Management",
    "Distribution Control",
    "System Reliability",
    "Grid Maintenance",
    "Network Planning",
    "Load Balancing",
    "Outage Management",
    "System Protection",
    "Grid Modernization",
    "Asset Management",
    "Emergency Response",
    "Performance Monitoring",
    "Quality Assurance",
    "Infrastructure Security",
    "Technical Support",
  ],

  "Smart Utilities": [
    "Smart Metering",
    "Grid Automation",
    "Data Analytics",
    "Network Management",
    "Demand Response",
    "Energy Efficiency",
    "Smart Infrastructure",
    "System Integration",
    "Digital Solutions",
    "Customer Engagement",
    "IoT Applications",
    "Predictive Maintenance",
    "Real-time Monitoring",
    "Smart Technology",
    "Innovation Management",
  ],

  "District Energy": [
    "Central Heating",
    "District Cooling",
    "Energy Distribution",
    "System Design",
    "Plant Operations",
    "Network Management",
    "Energy Efficiency",
    "Customer Service",
    "Infrastructure Maintenance",
    "System Optimization",
    "Environmental Management",
    "Resource Planning",
    "Quality Control",
    "Performance Monitoring",
    "Regulatory Compliance",
  ],
};

const real_estate_categories = {
  "Commercial Property": [
    "Office Buildings",
    "Retail Spaces",
    "Industrial Facilities",
    "Shopping Centers",
    "Business Parks",
    "Mixed-Use Developments",
    "Warehouses",
    "Hotels",
    "Restaurant Properties",
    "Entertainment Venues",
    "Parking Facilities",
    "Corporate Campuses",
    "Logistics Centers",
    "Commercial Leasing",
    "Property Operations",
  ],

  "Residential Property": [
    "Apartment Complexes",
    "Condominiums",
    "Multi-family Housing",
    "Student Housing",
    "Senior Living",
    "Affordable Housing",
    "Luxury Residences",
    "Townhouse Communities",
    "Single-family Rentals",
    "Mixed-income Housing",
    "Co-living Spaces",
    "Residential Leasing",
    "Property Maintenance",
    "Community Management",
    "Tenant Services",
  ],

  "Real Estate Investment": [
    "REITs",
    "Property Funds",
    "Investment Trusts",
    "Asset Management",
    "Portfolio Management",
    "Investment Strategy",
    "Capital Markets",
    "Real Estate Finance",
    "Investment Analysis",
    "Risk Management",
    "Property Acquisition",
    "Investment Sales",
    "Fund Management",
    "Investment Advisory",
    "Market Research",
  ],

  "Property Management": [
    "Facility Management",
    "Maintenance Services",
    "Tenant Relations",
    "Building Operations",
    "Security Services",
    "Lease Administration",
    "Property Accounting",
    "Vendor Management",
    "Asset Preservation",
    "Emergency Response",
    "Quality Control",
    "Sustainability Management",
    "Property Technology",
    "Compliance Management",
    "Service Coordination",
  ],

  "Real Estate Development": [
    "Project Planning",
    "Construction Management",
    "Site Selection",
    "Feasibility Studies",
    "Design Management",
    "Development Strategy",
    "Project Financing",
    "Permit Processing",
    "Construction Oversight",
    "Quality Assurance",
    "Sustainability Planning",
    "Project Marketing",
    "Development Analysis",
    "Risk Assessment",
    "Value Engineering",
  ],

  "Specialized Properties": [
    "Data Centers",
    "Healthcare Facilities",
    "Self-storage Facilities",
    "Educational Properties",
    "Research Facilities",
    "Sports Complexes",
    "Religious Buildings",
    "Government Facilities",
    "Cultural Centers",
    "Transportation Hubs",
    "Agricultural Properties",
    "Special Use Facilities",
    "Technology Parks",
    "Life Science Facilities",
    "Entertainment Venues",
  ],

  "Land Development": [
    "Site Preparation",
    "Infrastructure Development",
    "Zoning Analysis",
    "Environmental Assessment",
    "Land Planning",
    "Utilities Installation",
    "Subdivision Development",
    "Land Acquisition",
    "Entitlement Process",
    "Engineering Services",
    "Surveying Services",
    "Environmental Compliance",
    "Site Analysis",
    "Master Planning",
    "Land Use Planning",
  ],

  "Real Estate Services": [
    "Brokerage Services",
    "Property Appraisal",
    "Real Estate Consulting",
    "Marketing Services",
    "Transaction Management",
    "Due Diligence",
    "Market Analysis",
    "Advisory Services",
    "Property Valuation",
    "Legal Services",
    "Title Services",
    "Property Insurance",
    "Real Estate Technology",
    "Research Services",
    "Property Tours",
  ],
};

const communication_services_categories = {
  Telecommunications: [
    "Mobile Networks",
    "Fixed-line Services",
    "Internet Service Providers",
    "Data Services",
    "Voice Services",
    "Network Operations",
    "Wireless Communications",
    "Satellite Communications",
    "Telecom Infrastructure",
    "5G Services",
    "Enterprise Solutions",
    "Cloud Communications",
    "VoIP Services",
    "Unified Communications",
    "Telecom Security",
  ],

  "Media Entertainment": [
    "Film Production",
    "Television Production",
    "Music Production",
    "Streaming Services",
    "Content Distribution",
    "Entertainment Studios",
    "Animation Studios",
    "Production Services",
    "Content Licensing",
    "Live Entertainment",
    "Sports Entertainment",
    "Event Production",
    "Media Rights",
    "Content Creation",
    "Talent Management",
  ],

  "Digital Media": [
    "Social Networks",
    "Content Platforms",
    "Digital Advertising",
    "Online Content",
    "Digital Marketing",
    "Mobile Media",
    "Digital Publishing",
    "Streaming Platforms",
    "User Generated Content",
    "Digital Analytics",
    "Content Management",
    "Digital Distribution",
    "Online Communities",
    "Digital Strategy",
    "Media Technology",
  ],

  Broadcasting: [
    "Television Networks",
    "Radio Networks",
    "News Broadcasting",
    "Sports Broadcasting",
    "Network Operations",
    "Broadcasting Technology",
    "Program Distribution",
    "Content Production",
    "Live Broadcasting",
    "Digital Broadcasting",
    "Broadcast Engineering",
    "Program Scheduling",
    "Broadcast Rights",
    "Station Management",
    "Audience Research",
  ],

  Publishing: [
    "Book Publishing",
    "News Publishing",
    "Magazine Publishing",
    "Digital Publishing",
    "Academic Publishing",
    "Content Creation",
    "Editorial Services",
    "Distribution Networks",
    "Publishing Rights",
    "E-book Services",
    "Print Services",
    "Content Management",
    "Publishing Technology",
    "Market Research",
    "Publishing Analytics",
  ],

  "Interactive Media": [
    "Video Games",
    "Virtual Reality",
    "Augmented Reality",
    "Gaming Platforms",
    "Interactive Entertainment",
    "Social Gaming",
    "Mobile Gaming",
    "Game Development",
    "Virtual Worlds",
    "Interactive Content",
    "Gaming Technology",
    "User Experience",
    "Interactive Design",
    "Gaming Analytics",
    "Community Management",
  ],

  Advertising: [
    "Digital Advertising",
    "Traditional Advertising",
    "Media Planning",
    "Creative Services",
    "Ad Technology",
    "Marketing Strategy",
    "Campaign Management",
    "Media Buying",
    "Ad Analytics",
    "Brand Management",
    "Content Marketing",
    "Programmatic Advertising",
    "Ad Operations",
    "Performance Marketing",
    "Market Research",
  ],

  "Network Infrastructure": [
    "Network Equipment",
    "Data Centers",
    "Fiber Networks",
    "Wireless Infrastructure",
    "Network Security",
    "Cloud Infrastructure",
    "Network Management",
    "Infrastructure Services",
    "Network Maintenance",
    "Technology Integration",
    "Infrastructure Planning",
    "Network Operations",
    "Infrastructure Security",
    "Performance Monitoring",
    "Infrastructure Development",
  ],
};

const government_public_sector_categories = {
  "Public Administration": [
    "Federal Agencies",
    "State Government",
    "Local Government",
    "Policy Implementation",
    "Public Service Management",
    "Administrative Services",
    "Government Operations",
    "Regulatory Compliance",
    "Public Records",
    "Government Planning",
    "Fiscal Management",
    "Public Policy",
    "Government Relations",
    "Legislative Support",
    "Intergovernmental Affairs",
  ],

  "Defense and Security": [
    "Military Forces",
    "Law Enforcement",
    "National Security",
    "Intelligence Services",
    "Border Protection",
    "Emergency Management",
    "Homeland Security",
    "Defense Technology",
    "Military Operations",
    "Security Services",
    "Cybersecurity",
    "Counter-terrorism",
    "Defense Research",
    "Military Training",
    "Security Infrastructure",
  ],

  "Public Healthcare": [
    "Public Hospitals",
    "Community Health",
    "Public Health Programs",
    "Healthcare Administration",
    "Medical Research",
    "Health Policy",
    "Preventive Care",
    "Emergency Services",
    "Mental Health Services",
    "Public Health Labs",
    "Healthcare Access",
    "Health Education",
    "Disease Control",
    "Vaccination Programs",
    "Health Monitoring",
  ],

  Education: [
    "Public Schools",
    "State Universities",
    "Community Colleges",
    "Educational Programs",
    "Academic Research",
    "Special Education",
    "Adult Education",
    "Vocational Training",
    "Educational Technology",
    "Student Services",
    "Curriculum Development",
    "Educational Policy",
    "School Administration",
    "Teacher Training",
    "Educational Assessment",
  ],

  Infrastructure: [
    "Public Works",
    "Transportation Systems",
    "Public Buildings",
    "Utilities Management",
    "Urban Planning",
    "Infrastructure Development",
    "Facility Management",
    "Public Transit",
    "Road Systems",
    "Bridge Maintenance",
    "Port Facilities",
    "Airport Operations",
    "Infrastructure Security",
    "Project Management",
    "Asset Maintenance",
  ],

  "Social Services": [
    "Welfare Programs",
    "Community Support",
    "Public Assistance",
    "Child Services",
    "Elder Care",
    "Disability Services",
    "Housing Assistance",
    "Food Security",
    "Employment Services",
    "Family Services",
    "Youth Programs",
    "Crisis Intervention",
    "Rehabilitation Services",
    "Social Work",
    "Community Development",
  ],

  "Environmental Services": [
    "Environmental Protection",
    "Conservation Programs",
    "Pollution Control",
    "Natural Resources",
    "Wildlife Management",
    "Environmental Regulation",
    "Waste Management",
    "Water Quality",
    "Air Quality",
    "Environmental Assessment",
    "Climate Initiatives",
    "Sustainability Programs",
    "Environmental Research",
    "Resource Management",
    "Environmental Education",
  ],

  "Municipal Services": [
    "Emergency Response",
    "Sanitation Services",
    "Community Management",
    "Parks Recreation",
    "Public Safety",
    "Urban Services",
    "City Planning",
    "Waste Collection",
    "Street Maintenance",
    "Public Utilities",
    "Code Enforcement",
    "Community Programs",
    "Municipal Operations",
    "Local Development",
    "Citizen Services",
  ],
};

const healthcare_mapping = {
  "Healthcare Services": [
    "Healthcare Staffing",
    "Home Health Care & Residential Nursing",
    "Hospice Care",
    "In Vitro Diagnostics (IVD)",
    "Transdermal Drug Delivery (TDD)",
    "Market Research",
    "Healthcare Insurance",
    "Management Services Organization (MSO)",
    "Medical Waste Disposal",
    "Drug Testing",
    "Government-Sponsored Healthcare Programs",
    "Subrogation",
    "Healthcare Consulting",
    "Research",
    "Healthcare Education",
    "Adult Day Care",
    "Nursing",
    "Ambulance Services",
    "Healthcare Payer Services",
    "Health Plans",
    "Healthcare Solutions",
    "Biorepository ",
    "Healthcare Real Estate Development",
  ],

  "Medical Specialties": [
    "Behavioral Health",
    "Cardiology",
    "Chiropractic",
    "Consumer Healthcare",
    "Cosmetic Surgery",
    "Cosmetics",
    "Cytology",
    "Dentistry",
    "Dermatology",
    "Endocrinology (Diabetes)",
    "Eating Disorders",
    "Gastroenterology",
    "Alopecia",
    "Immunology",
    "Infectious Diseases",
    "Neurology",
    "Oncology",
    "Ophthalmology",
    "Physical Therapy",
    "Primary Care",
    "Psychology",
    "Speech-Language Pathology",
    "Urology",
    "Veterinary",
    "Orthodontics",
    "Orthopedics",
    "Applied Behavior Analysis (ABA)",
    "Anesthesiology",
    "Obstetrics",
    "Urogynecology",
    "Gynecology",
    "Forensics",
    "Orthodontistry",
    "Orthopedics",
    "Otolaryngology",
    "Pain Management",
    "Optometry",
    "Phlebology",
    "Podiatry",
    "Psychotherapy",
    "Pediatrics",
    "Hepatology",
    "Health & Wellness",
    "Infusion Therapy",
    "Radiology",
    "Plastic Surgery",
    "Cosmetic Surgery",
    "Palliative Care",
    "Weight Management",
    "Surrogacy",
    "Occupational Therapy",
    "Hematology",
    "Nephrology",
    "Acupuncture",
    "Audiology",
    "Andrology",
    "Psychiatry",
    "Sports Medicine",
    "Critical Care",
    "Electroencephalography",
    "Immuno-oncology",
    "Surgery",
    "Oral Surgery",
    "Pain Management",
    "Pulmonology",
    "Vaccines",
    "Internal Medicine",
    "Chronic Care",
    "Clean Medicine",
    "Neonatology",
    "Rheumatology",
    "Physiology",
    "Geriatrics",
    "Disability Care",
    "Senior Care",
    "Fertility",
    "Pathology",
    "Integrated Care",
    "Men's Health",
    "Women's Health",
  ],

  "Healthcare Products": [
    "Healthcare Products",
    "Medical Equipment & Supplies",
    "Medical Devices",
    "Surgical Devices",
    "Surgical Equipment & Supplies",
    "Biological Medical Product/Biologics",
    "Imaging Equipment",
    "Biotechnology Devices",
    "Healthcare Product Distribution",
  ],

  "Healthcare Centers": [
    "Diagnostic & Medical Laboratories",
    "Hospitals",
    "Clinical Laboratory Services",
    "Surgical Centers",
    "Urgent Care Centers",
    "Fertility Centers",
    "Imaging Services",
    "Ambulatory Surgery Centers",
    "Pharmaceutical Distribution Services",
    "Post-Acute Care",
    "Radiation Oncology Services",
    "Pharmacy",
    "Partial Hospitalization Programs (PHP)",
    "Residential Treatment Centers",
    "Outpatient Centers",
    "Inpatient Centers",
    "Assisted Living",
  ],

  "Health Sciences": [
    "Omics",
    "Clinical Trials",
    "Histology",
    "Pharmaceuticals",
    "Life Sciences",
    "Quality Control & Testing",
    "Drugs",
    "Drug Development",
    "Drug Discovery",
    "Contract Development and Manufacturing Organization (CDMO)",
    "Contract Research Organization Laboratory (CRO)",
    "Contract Assembly & Packaging",
    "Contract Engineering",
    "Supplements",
    "Contract Service Organizations (CSOs)",
    "Drug Delivery",
    "Drug Research",
    "Biopharmaceuticals",
    "Biotechnology",
  ],
};

export const narrow_specialty_defs = {
  ...healthcare_mapping,
  ...financial_categories,
  ...technology_categories,
  ...consumer_discretionary_categories,
  ...consumer_staples_categories,
  ...industrials_categories,
  ...energy_categories,
  ...materials_categories,
  ...utilities_categories,
  ...real_estate_categories,
  ...communication_services_categories,
  ...government_public_sector_categories,
};
